/* @flow strict */

export const portalHelper = (selector: string, callback: () => void): any => {
  const interval = setInterval((): () => void | boolean => {
    if (document.querySelector(selector)) {
      clearInterval(interval);

      return callback();
    }

    return false;
  }, 500);

  setTimeout(() => {
    if (interval) {
      clearInterval(interval);
    }
  }, 5000);
};
